import { render, staticRenderFns } from "./CarbonSummedContainer.vue?vue&type=template&id=2570d3ba&"
import script from "./CarbonSummedContainer.vue?vue&type=script&lang=js&"
export * from "./CarbonSummedContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports